// FfuDamFullPreview — "How a Dam Actually Works" (ffu_dam, production 5a23c95e).
// Factory Files Uncovered / US energy explainer lane.
// AUTO-GENERATED by docfactory/scripts/factory_pipeline/ffu_dam_overlays_gen.py —
// re-run `python3 ffu_dam_overlays_gen.py tsx` after editing the plan there, NEVER hand-patch this file. Every time literal below was resolved
// monotonically against productions.word_timestamps_hindi.
//
// composition: FfuDamFullPreview · fps-SAFE (registered @24fps for the 4K base;
// factory_4k_full hardcodes FPS=24) · 1280×704 · 63 overlays
// regions: BigStat/TextHighlight/EquationStack/EndCard = top-left,
//          Tag = lower-left, CTA pills = bottom-centre. No same-region overlaps.

import React from "react";
import { AbsoluteFill, Sequence, useVideoConfig } from "remotion";
import {
  PaletteProvider, BigStat, Tag, TextHighlight, EquationStack, EndCard,
} from "./overlayKit";
import { FFUDAM_PALETTE } from "./FfuDamFullPreviewPalette";
import { CTASubscribeBell } from "./cta/CTASubscribeBell";
import { CTACombinedBar } from "./cta/CTACombinedBar";

// ── MACHINE-READABLE OVERLAY WINDOWS ─────────────────────────────────────────
// Consumed by docfactory/scripts/assembly/build_overlay_windows.py, which regex-scans this
// file for `start: X, out: Y` literals to decide which frame ranges the 4K Modal fan-out has
// to render. It does NOT understand this kit's prop names (inS/outS, hiS/outS, valueS/endS)
// nor `from={f(x)}` pills — it only knows `start:/out:`. Without this block the extractor
// exits "!! no windows found" and the whole factory_4k_full render never fires.
// Generated from the same plan as the components below, so they cannot drift apart.
export const OVERLAY_WINDOWS = [
  { start: 0.578, out: 2.413 },
  { start: 2.563, out: 6.934 },
  { start: 5.242, out: 10.139 },
  { start: 20.017, out: 23.223 },
  { start: 32.604, out: 36.604 },
  { start: 52.284, out: 56.492 },
  { start: 69.039, out: 74.449 },
  { start: 73.251, out: 80.919 },
  { start: 83.999, out: 86.995 },
  { start: 90.092, out: 95.656 },
  { start: 119.486, out: 125.919 },
  { start: 132.127, out: 134.299 },
  { start: 134.449, out: 137.167 },
  { start: 137.317, out: 140.625 },
  { start: 140.775, out: 145.089 },
  { start: 144.133, out: 153.133 },
  { start: 156.088, out: 164.088 },
  { start: 165.918, out: 172.006 },
  { start: 182.566, out: 187.257 },
  { start: 186.029, out: 189.7 },
  { start: 191.566, out: 199.566 },
  { start: 200.157, out: 208.157 },
  { start: 209.485, out: 218.485 },
  { start: 225.977, out: 233.977 },
  { start: 239.816, out: 247.816 },
  { start: 254.469, out: 258.796 },
  { start: 271.609, out: 276.68 },
  { start: 276.005, out: 283.046 },
  { start: 289.452, out: 294.952 },
  { start: 302.583, out: 308.083 },
  { start: 308.21, out: 311.529 },
  { start: 311.679, out: 320.392 },
  { start: 326.819, out: 332.319 },
  { start: 332.492, out: 337.834 },
  { start: 341.132, out: 346.632 },
  { start: 349.413, out: 357.413 },
  { start: 361.487, out: 366.309 },
  { start: 382.412, out: 387.912 },
  { start: 397.734, out: 403.234 },
  { start: 408.404, out: 413.718 },
  { start: 421.608, out: 427.051 },
  { start: 439.199, out: 444.699 },
  { start: 449.104, out: 457.104 },
  { start: 459.518, out: 467.256 },
  { start: 466.291, out: 471.791 },
  { start: 475.689, out: 481.902 },
  { start: 482.052, out: 490.052 },
  { start: 502.992, out: 508.242 },
  { start: 509.591, out: 513.458 },
  { start: 513.608, out: 521.608 },
  { start: 526.837, out: 531.448 },
  { start: 531.598, out: 539.598 },
  { start: 549.473, out: 554.973 },
  { start: 556.725, out: 564.725 },
  { start: 577.693, out: 582.918 },
  { start: 582.972, out: 587.118 },
  { start: 587.268, out: 591.062 },
  { start: 591.212, out: 595.385 },
  { start: 595.535, out: 602.49 },
  { start: 606.736, out: 614.736 },
  { start: 617.05, out: 622.55 },
  { start: 646.036, out: 657.627 },
  { start: 646.836, out: 651.436 },
];

const CHANNEL = "Machine Room";

export const FfuDamFullPreview: React.FC = () => {
  // ⚠️ fps MUST come from the <Composition>, never a hardcoded const. This one comp is rendered
  // at TWO framerates: 16fps for the 0.5x preview (composited onto the 720p final) and 24fps for
  // the 4K pass — modal_factory_render.py::factory_4k_full hardcodes FPS=24 because the Topaz
  // base is Apollo-interpolated 16→24fps. A hardcoded 16 here puts every CTA pill ~1.5x early at
  // 4K. Every overlayKit component is already fps-safe (t = frame / useVideoConfig().fps).
  const { fps } = useVideoConfig();
  const f = (s: number) => Math.round(s * fps);
  return (
  <PaletteProvider value={FFUDAM_PALETTE}>
    <AbsoluteFill>

      {/* Channel logo is composited at the ffmpeg stage (modal_factory_render.py
          spec.add_logo + logo_url + logo_width). Do NOT bake it into the comp. */}

      <Tag
        label={"THICK AT THE TOP"}
        value={45}
        valueS={0.778}
        endS={1.416}
        suffix={" FT"}
        inS={0.578}
        outS={2.413}
        color={"accent"}
      />
      <Tag
        label={"THICK AT THE BOTTOM"}
        value={660}
        valueS={2.763}
        endS={3.773}
        suffix={" FT"}
        inS={2.563}
        outS={6.934}
        color={"accent"}
      />
      <BigStat
        value={15}
        suffix={"×"}
        sub={"THICKER AT THE BASE THAN AT THE CREST"}
        valueS={5.492}
        endS={5.933}
        outS={10.139}
        subColor={"cream"}
      />
      <TextHighlight
        pre={"Drain nine tenths of Lake Mead"}
        hi={"NOT BY A SINGLE INCH"}
        hiS={20.317}
        outS={23.223}
        hiColor={"accent"}
        preOwnLine={true}
      />
      <Sequence from={f(32.604)} durationInFrames={f(4.0)} layout="none">
        <CTASubscribeBell channel={CHANNEL} />
      </Sequence>
      <Tag hi={"1941"} label={"KEEP THIS YEAR IN YOUR HEAD"} inS={52.284} outS={56.492} color={"accent"} />
      <EquationStack
        l1={"A TALL THIN TUBE"}
        op={"vs"}
        l2={"A WIDE FLAT PAN"}
        l1S={69.039}
        opS={70.351}
        l2S={70.701}
        outS={74.449}
        l2Color={"accent"}
      />
      <Tag
        label={"FILLED TO THE SAME DEPTH"}
        value={6}
        valueS={73.451}
        endS={74.229}
        suffix={" IN"}
        inS={73.251}
        outS={80.919}
        color={"accent"}
      />
      <TextHighlight pre={"Pressure at the bottom of each"} hi={"IDENTICAL"} hiS={84.299} outS={86.995} hiColor={"accent"} />
      <EquationStack
        l1={"NOT HOW MUCH WATER"}
        op={"↓"}
        l2={"ONLY HOW DEEP"}
        l1S={90.092}
        opS={91.391}
        l2S={92.449}
        outS={95.656}
        l2Color={"accent"}
      />
      <EquationStack
        l1={"PUSHES SIDEWAYS"}
        op={"JUST AS HARD AS"}
        l2={"IT PUSHES DOWN"}
        l1S={119.486}
        opS={120.643}
        l2S={121.425}
        outS={125.919}
        l2Color={"accent"}
      />
      <Tag
        label={"AT THE SURFACE"}
        value={0}
        valueS={132.327}
        endS={133.024}
        suffix={" PSI"}
        inS={132.127}
        outS={134.299}
        color={"accent"}
      />
      <Tag
        label={"TEN FEET DOWN"}
        value={4}
        valueS={134.649}
        endS={135.334}
        suffix={" PSI"}
        inS={134.449}
        outS={137.167}
        color={"accent"}
      />
      <Tag
        label={"A HUNDRED FEET DOWN"}
        value={43}
        valueS={137.517}
        endS={138.806}
        suffix={" PSI"}
        inS={137.317}
        outS={140.625}
        color={"accent"}
      />
      <Tag
        label={"BUREAU OF RECLAMATION"}
        sub={"MAXIMUM PRESSURE AT THE BASE"}
        inS={140.775}
        outS={145.089}
        color={"primary"}
      />
      <EquationStack
        l1={"45,000 LB / FT²"}
        op={"÷ 144 IN²"}
        l2={"312 LB / IN²"}
        l1S={144.133}
        opS={148.045}
        l2S={150.727}
        outS={153.133}
        l2Color={"accent"}
      />
      <Tag
        label={"≈ FIRE-HOSE PRESSURE"}
        sub={"ON A WALL FOUR FOOTBALL FIELDS LONG"}
        inS={156.088}
        outS={164.088}
        color={"primary"}
      />
      <EquationStack
        l1={"PRESSURE RISES WITH DEPTH"}
        op={"→"}
        l2={"THE WALL GROWS\nTOWARD THE BASE"}
        l1S={165.918}
        opS={167.581}
        l2S={168.484}
        outS={172.006}
        l2Color={"accent"}
      />
      <Tag
        label={"LAKE MEAD REACHES BACK"}
        value={100}
        valueS={182.766}
        endS={183.857}
        suffix={" MILES"}
        inS={182.566}
        outS={187.257}
        color={"accent"}
      />
      <TextHighlight
        pre={"It does not feel the lake"}
        hi={"IT FEELS THE DEPTH"}
        hiS={186.329}
        outS={189.7}
        hiColor={"accent"}
        preOwnLine={true}
      />
      <Tag
        label={"INTAKE TOWERS"}
        sub={"TRASH RACKS SCREEN THE DEBRIS"}
        value={4}
        valueS={191.766}
        endS={192.892}
        inS={191.566}
        outS={199.566}
        color={"accent"}
      />
      <Tag
        label={"PENSTOCK"}
        sub={"STEEL PIPE · BIG ENOUGH TO DRIVE A TRUCK THROUGH"}
        inS={200.157}
        outS={208.157}
        color={"primary"}
      />
      <EquationStack
        l1={"HEIGHT"}
        op={"→"}
        l2={"SPEED + PRESSURE"}
        l1S={209.485}
        opS={209.885}
        l2S={210.317}
        outS={218.485}
        l2Color={"accent"}
      />
      <Tag
        label={"SPIRAL CASING"}
        sub={"TAPERS SO EVERY BLADE GETS AN EVEN PUSH"}
        inS={225.977}
        outS={233.977}
        color={"primary"}
      />
      <Tag
        label={"FRANCIS TURBINE"}
        sub={"CURVED BLADES ON A VERTICAL SHAFT"}
        inS={239.816}
        outS={247.816}
        color={"primary"}
      />
      <TextHighlight pre={"Not a water wheel"} hi={"THE WATER TURNS\nA CORNER"} hiS={254.769} outS={258.796} hiColor={"accent"} />
      <BigStat value={17} suffix={" GENERATORS"} valueS={271.859} endS={272.59} outS={276.68} subColor={"cream"} />
      <Tag label={"TRANSFORMERS → SWITCHYARD → LINES"} inS={276.005} outS={283.046} color={"primary"} />
      <BigStat
        value={2074}
        suffix={" MW"}
        sub={"NAMEPLATE CAPACITY · 17 MAIN GENERATORS"}
        valueS={289.702}
        endS={291.13}
        outS={294.952}
        subColor={"cream"}
      />
      <BigStat
        value={4.2}
        decimals={1}
        suffix={" BN kWh / YR"}
        sub={"1947 – 2008 AVERAGE"}
        valueS={302.833}
        endS={303.541}
        outS={308.083}
        subColor={"cream"}
      />
      <TextHighlight pre={""} hi={"NO FUEL"} post={"Nothing to burn"} hiS={308.51} outS={311.529} hiColor={"accent"} />
      <EquationStack
        l1={"THE SUN LIFTS IT"}
        op={"→"}
        l2={"GRAVITY BRINGS IT BACK"}
        l1S={311.679}
        opS={312.757}
        l2S={314.222}
        outS={320.392}
        l2Color={"accent"}
      />
      <BigStat
        value={3.25}
        decimals={2}
        suffix={" M YD³"}
        sub={"OF CONCRETE, IN ONE STRUCTURE"}
        valueS={327.069}
        endS={328.369}
        outS={332.319}
        subColor={"cream"}
      />
      <TextHighlight pre={"Poured as one mass"} hi={"A CENTURY\nTO COOL"} hiS={332.792} outS={337.834} hiColor={"accent"} />
      <BigStat
        value={582}
        suffix={" MILES OF PIPE"}
        sub={"REFRIGERATED WATER, BURIED IN THE CONCRETE"}
        valueS={341.382}
        endS={342.45}
        outS={346.632}
        subColor={"cream"}
      />
      <Tag
        label={"STILL IN THERE"}
        sub={"GROUTED UP AND ABANDONED IN PLACE"}
        inS={349.413}
        outS={357.413}
        color={"primary"}
      />
      <Tag
        label={"THOUSANDS OF TONS, MOVING FAST"}
        sub={"INSIDE THE PENSTOCK"}
        inS={361.487}
        outS={366.309}
        color={"primary"}
      />
      <TextHighlight
        pre={""}
        hi={"WATER HAMMER"}
        post={"Your washing machine does it too"}
        hiS={382.712}
        outS={387.912}
        hiColor={"accent"}
        preOwnLine={true}
      />
      <TextHighlight
        pre={"Not a few percent above normal"}
        hi={"A LARGE MULTIPLE"}
        hiS={398.034}
        outS={403.234}
        hiColor={"accent"}
        preOwnLine={true}
      />
      <TextHighlight
        pre={"That is not caution"}
        hi={"A HARD ENGINEERING\nREQUIREMENT"}
        hiS={408.704}
        outS={413.718}
        hiColor={"accent"}
      />
      <EquationStack
        l1={"NOT FROM HEAT"}
        op={"↓"}
        l2={"FROM LACK OF PRESSURE"}
        l1S={421.608}
        opS={422.44}
        l2S={422.56}
        outS={427.051}
        l2Color={"accent"}
      />
      <TextHighlight
        pre={""}
        hi={"CAVITATION"}
        post={"Over time, bubbles eat steel"}
        hiS={439.499}
        outS={444.699}
        hiColor={"accent"}
      />
      <Tag
        hi={"1941"}
        label={"SPILLWAY RUN HARD"}
        sub={"HIGH SPEED, AROUND A BEND"}
        inS={449.104}
        outS={457.104}
        color={"accent"}
      />
      <Tag
        label={"115 FT LONG · 30 FT WIDE · 45 FT DEEP"}
        sub={"TORN OUT OF THE CONCRETE LINING"}
        inS={459.518}
        outS={467.256}
        color={"primary"}
      />
      <TextHighlight pre={"Not cracked"} hi={"EXCAVATED.\nBY BUBBLES."} hiS={466.591} outS={471.791} hiColor={"accent"} />
      <Tag
        hi={"1941"}
        label={"THE FIX: REALIGN + POLISH"}
        sub={"TREATS THE SURFACE, NOT THE CAUSE"}
        inS={475.689}
        outS={481.902}
        color={"accent"}
      />
      <Tag
        hi={"1942"}
        label={"AIR PUSHED INTO THE FLOW"}
        sub={"TESTED AT HOOVER · IT DID NOT WORK"}
        inS={482.052}
        outS={490.052}
        color={"accent"}
      />
      <BigStat
        value={26}
        suffix={" YEARS"}
        sub={"BEFORE ANYONE COULD STOP IT"}
        valueS={503.242}
        endS={503.974}
        outS={508.242}
        subColor={"cream"}
      />
      <Tag
        hi={"1967"}
        label={"YELLOWTAIL DAM"}
        sub={"FIRST WORKING SPILLWAY AERATOR"}
        inS={509.591}
        outS={513.458}
        color={"accent"}
      />
      <Tag
        hi={"1964"}
        label={"GLEN CANYON FINISHED"}
        sub={"THREE YEARS BEFORE THE SOLUTION EXISTED"}
        inS={513.608}
        outS={521.608}
        color={"accent"}
      />
      <Tag hi={"1984"} label={"AERATORS SCHEDULED FOR GLEN CANYON"} inS={526.837} outS={531.448} color={"accent"} />
      <Tag
        hi={"JUNE 1983"}
        label={"RECORD RUNOFF"}
        sub={"BOTH SPILLWAYS, CONTINUOUSLY, FOR DAYS"}
        inS={531.598}
        outS={539.598}
        color={"accent"}
      />
      <TextHighlight
        pre={"The fix was already approved"}
        hi={"THE WATER CAME FIRST"}
        hiS={549.773}
        outS={554.973}
        hiColor={"accent"}
        preOwnLine={true}
      />
      <Tag
        hi={"1987"}
        label={"HOOVER FINALLY GETS AERATORS"}
        sub={"46 YEARS AFTER 1941 · 3 AFTER GLEN CANYON"}
        inS={556.725}
        outS={564.725}
        color={"accent"}
      />
      <Tag
        label={"MINIMUM POWER POOL"}
        value={950}
        valueS={577.893}
        endS={578.718}
        suffix={" FT"}
        inS={577.693}
        outS={582.918}
        color={"accent"}
      />
      <BigStat
        value={117}
        suffix={" MW"}
        sub={"DOWN FROM ~2,000 MW AT FULL POOL"}
        valueS={583.222}
        endS={584.314}
        outS={587.118}
        subColor={"cream"}
      />
      <BigStat
        value={6}
        suffix={"%"}
        sub={"OF WHAT IT MAKES TODAY"}
        valueS={587.518}
        endS={588.087}
        outS={591.062}
        subColor={"cream"}
      />
      <TextHighlight pre={"Not gradually"} hi={"IT FALLS OFF A CLIFF"} hiS={591.512} outS={595.385} hiColor={"accent"} />
      <EquationStack
        l1={"45 FT AT THE TOP"}
        op={"↓"}
        l2={"660 FT AT THE BOTTOM"}
        l1S={595.535}
        opS={597.183}
        l2S={597.207}
        outS={602.49}
        l2Color={"accent"}
      />
      <Tag
        label={"OF WATER ABOVE THE BASE"}
        sub={"312 LB ON EVERY SQUARE INCH"}
        value={590}
        valueS={606.936}
        endS={607.9}
        suffix={" FT"}
        inS={606.736}
        outS={614.736}
        color={"accent"}
      />
      <TextHighlight
        pre={"Not holding back a lake"}
        hi={"HOLDING BACK A DEPTH"}
        hiS={617.35}
        outS={622.55}
        hiColor={"accent"}
        preOwnLine={true}
      />
      <EndCard
        channel={CHANNEL}
        tagline1={"NEXT: ONE BUILDING"}
        tagline2={"THAT OUTDRAWS THIS DAM"}
        cta={"SUBSCRIBE · NEW EPISODE EVERY WEEK"}
        atS={646.036}
        outS={657.627}
      />
      <Sequence from={f(646.836)} durationInFrames={f(4.6)} layout="none">
        <CTACombinedBar />
      </Sequence>

    </AbsoluteFill>
  </PaletteProvider>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
